import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, photoUrl } from "@/lib/api";
import { Cake, PawPrint } from "lucide-react";
import { BIRTHDAY } from "@/constants/testIds";

export default function BirthdayStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/pets/birthdays/upcoming").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid={BIRTHDAY.strip} className="mb-10">
      <div className="flex items-center gap-2 mb-4">
        <Cake className="w-5 h-5 text-[#E76F51]" />
        <div className="font-hand text-2xl text-[#E76F51]">birthday countdown</div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/pets/${p.id}`}
            data-testid={BIRTHDAY.card}
            className="rounded-3xl overflow-hidden bg-white border border-[#EAE2D6] warm-shadow hover:-translate-y-1 transition-transform flex"
          >
            <div className="w-28 shrink-0 relative" style={{ backgroundColor: `${p.color}22` }}>
              {p.hero_photo_id ? (
                <img src={photoUrl(p.hero_photo_id)} alt={p.name} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <PawPrint className="w-8 h-8" style={{ color: p.color }} />
                </div>
              )}
            </div>
            <div className="p-4 flex-1 min-w-0">
              <div className="font-display text-xl font-bold text-[#2D232E] truncate">{p.name}</div>
              <div className="font-hand text-lg leading-tight" style={{ color: p.color }}>
                {p.days_until === 0
                  ? `turns ${p.turning} today! 🎉`
                  : p.days_until === 1
                  ? `turns ${p.turning} tomorrow!`
                  : `turns ${p.turning} in ${p.days_until} days`}
              </div>
              <div className="text-xs text-[#6A606C] mt-1 capitalize">{p.breed || p.species}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
